// URL CONFIGURATION SECTION START
export const SEND_OTP_URL = '/user-onboarding/api/v1/otp/send';
export const VERIFY_OTP_URL = '/user-onboarding/api/v1/otp/verify';
export const GET_ACCESSTOKEN_URL = '/user-onboarding/api/v1/access-token';
export const ORDER_API_URL = '/api/v1/order';

// URL CONFIGURATION SECTION END

// CONSTANT SECTION START
export const USER_NOT_CONFIRMED = 'Please complete your onboarding on SOLV app for using seller portal. Reach out to us at cs@solvezy.com for any assistance'
// CONSTANT SECTION END


